<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getLookups");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.users.totalItems / this.filters.pageSize
      );
    },

    users() {
      return this.$store.state.users.users;
    },
    userTypes() {
      return [
        { value: 0, label: "الكل", type: this.$lookupTypes.UserTypes },
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.UserTypes
        )];
    },
  },

  data() {
    return {
      permissions: this.$settingPermissions.userPermissions,

      view: 0,

      filters: {
        page: 1,
        pageSize: 10,

        loginName: null,
        userTypeId: null,
      },
      headers: [
        { text: 'اسم بالكامل', value: 'fullName' },
        { text: 'اسم المستخدم', value: 'loginName' },
        { text: 'نوع المستخدم', value: 'userType' },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: "الحالة", value: "status", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("users/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },


    back() {
      this.view = 0;
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف حساب المستخدم؟";
          break;
        case "lock":
          this.dialogMessage = "هل انت متأكد من رغبتك تجميد حساب المستخدم؟";
          break;
        case "unlock":
          this.dialogMessage = "هل انت متأكد من رغبتك تفعيل حساب المستخدم؟";
          break;
        case "resetPassword":
          this.dialogMessage = "هل انت متأكد من رغبتك اعادة تعيين كلمة المرور ";
          break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      switch (this.dialogType) {
        case "resetPassword": {
          this.$store.dispatch(`users/${this.dialogType}`, this.itemId);
          break;
        }
        default: {
          this.$store.dispatch(`users/${this.dialogType}`, this.itemId);
        }
      }
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
  },
};
</script>

<style scoped></style>